// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.App {
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  height: 100vh;
  flex-direction: row;
}

.navbar-custom {
  font-size:large;
}

.navbar__link {
  margin-left: 0.75em;
  margin-right: 0.75em;
  font-size: 1em;
  cursor: pointer;
  text-decoration: none;
  letter-spacing: .1em;
  text-indent: .3em;
  border-bottom: 3px solid transparent;
}

.navbar__link::after {
  transition: all ease-in-out .2s;
  background: none repeat scroll 0 0;
  content: "";
  display: block;
  margin-top: 2px;
  height: 3px;
  width: 0;
}

 .navbar__link:hover::after {
  visibility: visible;
  width: 40%;
}

.navbar__link--active::after {
  transition: all ease-in-out .2s;
  width: 100%;
}

.navbar__link--active:hover::after {
  width: 100%;
}

.MainApp {
  margin-top: 8vh;
  height: 90vh;
}

.main {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.section-content-container {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
}

.Typewriter {
  display: inline-block;
}

.Typewriter__wrapper {
  font-size: xx-large;
  font-weight: bold;
}

.Typewriter__cursor {
  font-size: xx-large;
  font-weight: bold;
}

section.timeline-card-content {
  justify-content: center;
}

section.timeline-card-content p.card-title {
  font-size: 1.5em;
  margin-top: 25px;
}

section.timeline-card-content p.card-sub-title {
  font-size: 1.25em;
  margin-top: 10px;
}

section.timeline-card-content div.card-description > p {
  font-size: 1.1em;
  margin-top: 10px;
  font-weight: 500;
}

.social {
  position: relative;
  margin-top: 60px;
}


@media only screen and (min-width: 768px) and (max-width: 992px) {

  .navbar__link {
    margin-left: 0.4em;
    margin-right: 0.4em;
    font-size: 0.9em;
    cursor: pointer;
    letter-spacing: .1em;
    text-indent: .2em;
  }
}

@media (max-width: 768px) {

  .navbar__link::after {
    background: none;
    content: "";
    display: none;
    margin-top: 0;
    height: 0;
    width: 0;
  }

  .navbar__link--active::after {
    width: 0;
  }
  
  .navbar__link--active:hover::after {
    width: 0;
  }

  .navbar__link:hover::after {
    width: 0;
  }
}

.header {
  font-size: 3em;
  font-weight: bold;
  margin-bottom: 25px;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,WAAW;EACX,cAAc;EACd,eAAe;EACf,WAAW;EACX,QAAQ;AACV;;CAEC;EACC,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;;EAEE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;EACnB;AACF;;AAEA;;EAEE;IACE,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,aAAa;IACb,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":["\n.App {\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  height: 100vh;\n  flex-direction: row;\n}\n\n.navbar-custom {\n  font-size:large;\n}\n\n.navbar__link {\n  margin-left: 0.75em;\n  margin-right: 0.75em;\n  font-size: 1em;\n  cursor: pointer;\n  text-decoration: none;\n  letter-spacing: .1em;\n  text-indent: .3em;\n  border-bottom: 3px solid transparent;\n}\n\n.navbar__link::after {\n  transition: all ease-in-out .2s;\n  background: none repeat scroll 0 0;\n  content: \"\";\n  display: block;\n  margin-top: 2px;\n  height: 3px;\n  width: 0;\n}\n\n .navbar__link:hover::after {\n  visibility: visible;\n  width: 40%;\n}\n\n.navbar__link--active::after {\n  transition: all ease-in-out .2s;\n  width: 100%;\n}\n\n.navbar__link--active:hover::after {\n  width: 100%;\n}\n\n.MainApp {\n  margin-top: 8vh;\n  height: 90vh;\n}\n\n.main {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.section-content-container {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: center;\n  align-items: center;\n}\n\n.Typewriter {\n  display: inline-block;\n}\n\n.Typewriter__wrapper {\n  font-size: xx-large;\n  font-weight: bold;\n}\n\n.Typewriter__cursor {\n  font-size: xx-large;\n  font-weight: bold;\n}\n\nsection.timeline-card-content {\n  justify-content: center;\n}\n\nsection.timeline-card-content p.card-title {\n  font-size: 1.5em;\n  margin-top: 25px;\n}\n\nsection.timeline-card-content p.card-sub-title {\n  font-size: 1.25em;\n  margin-top: 10px;\n}\n\nsection.timeline-card-content div.card-description > p {\n  font-size: 1.1em;\n  margin-top: 10px;\n  font-weight: 500;\n}\n\n.social {\n  position: relative;\n  margin-top: 60px;\n}\n\n\n@media only screen and (min-width: 768px) and (max-width: 992px) {\n\n  .navbar__link {\n    margin-left: 0.4em;\n    margin-right: 0.4em;\n    font-size: 0.9em;\n    cursor: pointer;\n    letter-spacing: .1em;\n    text-indent: .2em;\n  }\n}\n\n@media (max-width: 768px) {\n\n  .navbar__link::after {\n    background: none;\n    content: \"\";\n    display: none;\n    margin-top: 0;\n    height: 0;\n    width: 0;\n  }\n\n  .navbar__link--active::after {\n    width: 0;\n  }\n  \n  .navbar__link--active:hover::after {\n    width: 0;\n  }\n\n  .navbar__link:hover::after {\n    width: 0;\n  }\n}\n\n.header {\n  font-size: 3em;\n  font-weight: bold;\n  margin-bottom: 25px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
